import { styled, theme } from 'ui/theme';

export const ComboComponents = {
  ButtonContent: styled('div')`
    display: flex;
    justify-content: center;
    gap: ${theme.space[1]};
  `,
};
